var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 116C25.9675 116 0 90.0325 0 58C0 25.9675 25.9675 0 58 0C90.0325 0 116 25.9675 116 58C116 90.0325 90.0325 116 58 116Z",
    fill: "#FF1E2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5374 84.4621C33.7123 86.637 37.3375 86.637 39.5124 84.4621L57.9997 65.9748L76.487 84.4621C78.6619 86.637 82.2872 86.637 84.4621 84.4621C86.637 82.2873 86.637 78.662 84.4621 76.4871L65.9748 57.9998L84.4621 39.5125C86.637 37.3376 86.637 33.7123 84.4621 31.5374C82.2872 29.3625 78.6619 29.3625 76.487 31.5374L57.9997 50.0247L39.5124 31.5374C37.3375 29.3625 33.7123 29.3625 31.5374 31.5374C29.3625 33.7123 29.3625 37.3376 31.5374 39.5125L50.0247 57.9998L31.5374 76.4871C29.3625 78.662 29.3625 82.2869 31.5374 84.4621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsError);
export default __webpack_public_path__ + "static/media/icons-error.dea624777dc889b3e82433306a61ca74.svg";
export { ForwardRef as ReactComponent };